export default __webpack_public_path__ + "static/media/jpeg.bcf892be.svg";